(function () {
  var COOKIE = "sh_dual_optin";
  var API = "https://skyhigh-ops.fly.dev/api/public/dual-opt-in";
  var DELAY_MS = 8000;

  function cookieGet(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : "";
  }
  function cookieSet(name, val, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + "=" + encodeURIComponent(val) + "; expires=" + exp + "; path=/; SameSite=Lax";
  }
  function skipPage() {
    var p = location.pathname || "";
    if (/\/checkouts?\b|\/cart|\/account|\/pages\/alerts|\/pages\/updates/.test(p)) return true;
    if (window.Shopify && Shopify.Checkout) return true;
    return false;
  }

  var force = /(?:\?|&)popup=([12])\b/.test(location.search)
    ? RegExp.$1
    : "";
  var root = document.getElementById("sh-dual");
  if (!root || skipPage()) return;
  document.body.classList.add("sh-dual-on");
  /* Fix A3: Klaviyo still adds klaviyo-prevent-body-scrolling (overflow:hidden !important)
     even when its forms are CSS-hidden by .sh-dual-on — invisible permanent freeze. */
  (function neutralizeKlaviyoScrollLock() {
    function clear() {
      if (document.body.classList.contains("klaviyo-prevent-body-scrolling")) {
        document.body.classList.remove("klaviyo-prevent-body-scrolling");
      }
    }
    clear();
    if (window.MutationObserver) {
      new MutationObserver(clear).observe(document.body, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }
  })();
  if (cookieGet(COOKIE) && !force) return;

  var emailVal = "";
  var renderedAt = Date.now();
  var shown = false;
  var locked = false;
  var savedY = 0;

  function showStep(n) {
    root.querySelectorAll("[data-step]").forEach(function (el) {
      el.hidden = String(el.getAttribute("data-step")) !== String(n);
    });
  }
  function lockScroll() {
    /* Fix A2: no-op — never lock html/body. Overlay is position:fixed; iOS overflow:hidden freezes cold first-visit scroll. */
  }
  function unlockScroll() {
    document.documentElement.classList.remove("sh-dual-lock");
    document.body.classList.remove("klaviyo-prevent-body-scrolling");
    document.body.style.overflow = "";
    document.documentElement.style.removeProperty("--sh-dual-scroll");
    if (document.body.style.position === "fixed") document.body.style.position = "";
    if (locked) {
      locked = false;
      try {
        window.scrollTo(0, savedY);
      } catch (e) {}
    }
  }
  function open() {
    if (shown || cookieGet(COOKIE)) return;
    shown = true;
    renderedAt = Date.now();
    root.hidden = false;
  }
  function close(days) {
    root.hidden = true;
    unlockScroll();
    cookieSet(COOKIE, "1", days || 14);
  }
  function post(body) {
    body.company_website = (document.getElementById("sh-dual-hp") || {}).value || "";
    body.renderedAt = renderedAt;
    body.source = "site-popup";
    return fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    });
  }
  function fail(id, text) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    el.textContent = text;
  }

  document.querySelectorAll("[data-sh-dual-dismiss]").forEach(function (el) {
    el.addEventListener("click", function () { close(14); });
  });

  var emailForm = document.getElementById("sh-dual-email");
  if (emailForm) {
    emailForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var age = document.getElementById("sh-dual-age");
      var input = document.getElementById("sh-dual-email-input");
      var btn = emailForm.querySelector('button[type="submit"]');
      if (!age.checked) { fail("sh-dual-msg1", "Confirm you are 21 or older."); return; }
      emailVal = (input.value || "").trim();
      if (!emailVal) { fail("sh-dual-msg1", "Enter a valid email."); return; }
      btn.disabled = true;
      post({
        email: emailVal,
        emailConsent: true,
        smsConsent: false,
        age21: true
      }).then(function (x) {
        if (!(x.j && x.j.ok)) {
          fail("sh-dual-msg1", (x.j && (x.j.message || x.j.error)) || "Could not save that.");
          btn.disabled = false;
          return;
        }
        showStep(2);
      }).catch(function () {
        fail("sh-dual-msg1", "Network error. Try again.");
        btn.disabled = false;
      });
    });
  }

  var smsForm = document.getElementById("sh-dual-sms");
  if (smsForm) {
    smsForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var phone = (document.getElementById("sh-dual-phone").value || "").trim();
      var smsOn = document.getElementById("sh-dual-sms-consent").checked;
      var btn = smsForm.querySelector('button[type="submit"]');
      if (!phone || !smsOn) {
        document.getElementById("sh-dual-done").textContent = "Email is on. Tap below — $10 off $40+ is on checkout. Log in once with that email to see Frequent Flyer.";
        showStep("done");
        cookieSet(COOKIE, "1", 90);
        unlockScroll();
        return;
      }
      btn.disabled = true;
      post({
        email: emailVal,
        phone: phone,
        emailConsent: true,
        smsConsent: true,
        age21: true
      }).then(function (x) {
        var copy = "Texts are on. Tap below — $10 off $40+ is on checkout. 200 Frequent Flyer points are on the way — log in once with that email (6-digit code) to see them.";
        if (x.j && x.j.sms === "refuse_sms") copy = x.j.message || "Email is on. We couldn't add texts on this number.";
        else if (!(x.j && x.j.ok)) copy = (x.j && (x.j.message || x.j.error)) || copy;
        document.getElementById("sh-dual-done").textContent = copy;
        showStep("done");
        cookieSet(COOKIE, "1", 90);
        unlockScroll();
      }).catch(function () {
        fail("sh-dual-msg2", "Network error. Try again.");
        btn.disabled = false;
      });
    });
  }
  var skipSms = document.getElementById("sh-dual-skip-sms");
  if (skipSms) {
    skipSms.addEventListener("click", function () {
      document.getElementById("sh-dual-done").textContent = "Email is on. Tap below — $10 off $40+ is on checkout.";
      showStep("done");
      cookieSet(COOKIE, "1", 90);
      unlockScroll();
    });
  }

  var shop = document.getElementById("sh-dual-shop");
  if (shop) {
    shop.addEventListener("click", function () {
      unlockScroll();
    });
  }
  window.addEventListener("pageshow", function () {
    if (root.hidden || cookieGet(COOKIE)) unlockScroll();
  });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible" && (root.hidden || cookieGet(COOKIE))) unlockScroll();
  });

  if (force) {
    open();
    if (force === "2") showStep(2);
  } else {
    setTimeout(open, DELAY_MS);
  }
})();
